import App from './App.vue';

export default {
  path: '/CDS_VF_ChronologyDetail',
  name: 'CDS_VF_ChronologyDetail',
  component: App,
  meta: {
    pageProperty: {
      title: 'クロノロジー',
      controller: 'CDS_CTR_ChronologyDetail',
    },
  },
};
